<template>
  <TheNuxtLink
    id="tracking_contactUs"
    :to="`/${locale}/marketplace/help/contact-us`"
    :title="$t('header.contact-us')"
    class="flex h-8 w-8 items-center justify-center hover:rounded hover:bg-blue-400/10"
  >
    <IconMail class="h-5 w-5 text-blue-400" />
  </TheNuxtLink>
</template>

<script setup lang="ts">
  const { locale } = useI18n();
</script>
